import type { ReactNode } from 'react';
import { cn } from './utils';

export interface FieldProps {
  /** Id of the control this field labels. */
  id?: string;
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  className?: string;
  children: ReactNode;
}

/**
 * Layout wrapper that renders a label, the control, and either the error or the
 * hint beneath it. Used by Input, Textarea and Select.
 */
export function Field({ id, label, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cn('flex w-full flex-col gap-1.5', className)}>
      {label !== undefined && label !== null ? (
        <label htmlFor={id} className="text-sm font-medium text-zinc-900">
          {label}
          {required ? (
            <span className="ml-0.5 text-red-600" aria-hidden="true">
              *
            </span>
          ) : null}
        </label>
      ) : null}
      {children}
      {error !== undefined && error !== null && error !== false ? (
        <p role="alert" className="text-sm text-red-600">
          {error}
        </p>
      ) : hint !== undefined && hint !== null ? (
        <p className="text-sm text-zinc-500">{hint}</p>
      ) : null}
    </div>
  );
}
